<script setup>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import Breadcrumbs from "../Breadcrumbs.vue";

const showMenu = ref(false);
const store = useStore();
const isRTL = computed(() => store.state.isRTL);

const route = useRoute();

const currentRouteName = computed(() => {
  return route.name;
});
const currentDirectory = computed(() => {
  let dir = route.path.split("/")[1];
  return dir.charAt(0).toUpperCase() + dir.slice(1);
});

const minimizeSidebar = () => store.commit("sidebarMinimize");
const toggleConfigurator = () => store.commit("toggleConfigurator");

const closeMenu = () => {
  setTimeout(() => {
    showMenu.value = false;
  }, 100);
};
</script>
<template>
  <nav
    class="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl"
    :class="isRTL ? 'top-0 position-sticky z-index-sticky' : ''"
    v-bind="$attrs"
    id="navbarBlur"
    data-scroll="true"
  >
    <div class="px-3 py-1 container-fluid">
      <breadcrumbs
        :current-page="currentRouteName"
        :current-directory="currentDirectory"
      />

      <div
        class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4"
        :class="isRTL ? 'px-0' : 'me-sm-4'"
        id="navbar"
      >
        <div
          class="pe-md-3 d-flex align-items-center"
          :class="isRTL ? 'me-md-auto' : 'ms-md-auto'"
        >
          <div class="input-group">
          
          </div>
        </div>
        <ul class="navbar-nav justify-content-end">

          <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
            <a
              href="#"
              @click="minimizeSidebar"
              class="p-0 nav-link text-white"
              id="iconNavbarSidenav"
            >
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line bg-black"></i>
                <i class="sidenav-toggler-line bg-black"></i>
                <i class="sidenav-toggler-line bg-black"></i>
              </div>
            </a>
          </li>
          &nbsp;&nbsp;
          <!--
          <li class="px-3 nav-item d-flex align-items-center">
            <a class="p-0 nav-link text-white" @click="toggleConfigurator">
              <i class="cursor-pointer fa fa-cog fixed-plugin-button-nav"></i>
            </a>
          </li>
          -->

          <li class="nav-item dropdown d-flex align-items-center" :class="isRTL ? 'ps-2' : 'pe-2'">
            <a
                href="#"
                class="p-0 nav-link text-white position-relative"
                :class="[showMenu ? 'show' : '']"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                @click="showMenu = !showMenu"
                @blur="closeMenu"
            >
              <i class="cursor-pointer fa fa-bell" style="color: black"></i>
              <span v-if="expiringContracts.length > 0"
                    class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
      {{ expiringContracts.length }}
    </span>
            </a>

            <ul class="px-2 py-3 dropdown-menu dropdown-menu-end me-sm-n4"
                :class="showMenu ? 'show' : ''"
                aria-labelledby="dropdownMenuButton">

              <li v-if="expiringContracts.length === 0" class="mb-2">
                <a class="dropdown-item border-radius-md" href="javascript:;">
                  <p class="mb-0 text-sm text-center">Yaklaşan sözleşme yok</p>
                </a>
              </li>

              <li v-for="(contract, index) in expiringContracts" :key="index" class="mb-2">
                <a class="dropdown-item border-radius-md" href="javascript:;">
                  <div class="py-1 d-flex">
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-1 text-sm font-weight-normal">
                        <span class="font-weight-bold">{{ contract.company }} - {{ contract.contractNumber }}</span> sözleşmesi yaklaşıyor!
                      </h6>
                      <p class="mb-0 text-xs text-secondary">
                        <i class="fa fa-clock me-1"></i>
                        {{ contract.remainingDays }} gün kaldı
                      </p>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import apiClient from "@/axios";

export default {
  name: "Navbar",
  data() {
    return {
      contractData: [],
      expiringContracts: [],
    };
  },
  created() {
    this.getContractData();
  },
  methods: {
    getContractData() {
      apiClient.get("contract").then(res => {
        this.contractData = res.data;
        this.checkExpiringContracts();
      });
    },
    checkExpiringContracts() {
      const today = new Date();
      this.expiringContracts = this.contractData
          .map(contract => {
            const renewalDate = new Date(contract.renewalcontractdate);
            const remainingDays = Math.ceil((renewalDate - today) / (1000 * 3600 * 24));

            return remainingDays > 0 && remainingDays < 30 ? {
              company: contract.companyname,
              contractNumber: contract.contractnumber,
              remainingDays
            } : null;
          })
          .filter(Boolean);
    }
  }
};
</script>
